import React from "react";
import { Outlet } from "react-router-dom";
import RcAccess from "./RcAccess";
import RcView from "./RcView";

const RcPage = () => (
  <div className="layout-content px-3 sm:px-5 md:px-5">
    <Outlet />
  </div>
);

export { RcPage, RcAccess, RcView };
